const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const CPAPI = `//m-cpapi${spell}.xinli001.com/cp/service/`,
    HCP = `//hcp${spell}.xinli001.com/`,
    LXDOMAIN = spell?`//lingxi${spell}.xinli001.com/lingxi/service/`:`//m-lingxi${spell}.xinli001.com/lingxi/service/`,
    APIS = {
        // 2020双十一活动
        doubleElevenScalePackages: `${LXDOMAIN}doubleEleven/getScalePackages`, // 指定解决方案列表
        doubleElevenScaleCombos: `${LXDOMAIN}doubleEleven/getScaleCombos`, // 必测心理测评套餐
        doubleElevenScaleRankList: `${LXDOMAIN}doubleEleven/getScaleRankList`, // 畅销测评排行榜
        doubleElevenScalePricePlan: `${LXDOMAIN}doubleEleven/getScalePricePlan`, // 获取价格方案接口
        doubleElevenConsultPackages: `${LXDOMAIN}doubleEleven/getConsultPackages`, // 咨询师价格方案列表、购买状态
        doubleElevenReceiveCoupon: `${LXDOMAIN}doubleEleven/receive`, // 领优惠券接口
    }

export default APIS


// WEBPACK FOOTER //
// ./src/apis/activity.js